// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__v0RLE","cardDescription":"Cards_cardDescription__jAkb7","heading":"Cards_heading__WtJrz","text":"Cards_text__MLl9B"};